  export const environment = {
    production: false,
    serverUrl: 'https://luxx73ujgl.execute-api.us-east-2.amazonaws.com/dev',
    bucket: 'sanofi-beta-upload',
    userPool: {
      UserPoolId: 'us-east-2_8aUIHwZrX',
      ClientId: '6od1e5j63oglnpgs6kr72tle68',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:6038394e-99c1-448f-870a-47102e0645a5',
    buckets: {
      'us-east-2': 'sanofi-beta-upload'
    },
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId:'us-east-2:6038394e-99c1-448f-870a-47102e0645a5', //REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_8aUIHwZrX', //OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '6od1e5j63oglnpgs6kr72tle68', //OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'sanofi-beta-upload', //REQUIRED -  Amazon S3 bucket
        region: 'us-east-2', //OPTIONAL -  Amazon service region
      }
    }
  };

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolClientId: '6od1e5j63oglnpgs6kr72tle68',
      userPoolId: 'us-east-2_8aUIHwZrX',
      identityPoolId: 'us-east-2:6038394e-99c1-448f-870a-47102e0645a5'
    }
  },
  Storage: {
    S3: {
      bucket: 'sanofi-beta-upload',
      region: 'us-east-2'
    }
  }
};
export default awsconfig;